import { getCardRates, hasPositiveRate, isIssuedCard, selectedCards } from '@shared-core/features/backend'
import { useNotifications } from '@shared-core/features/notifications'
import { useCardTemplates } from '@shared-core/hooks/use-card-templates'
import { useEvent } from '@shared-core/hooks/use-event'
import { useI18N } from '@shared-core/hooks/use-i18n'
import { useAppSelector } from '@shared-core/store'
import locales from './use-card-operation-availability.i18n.json'

export function useCardOperationAvailability() {
  const cards = useAppSelector(selectedCards)
  const templates = useCardTemplates()
  const { addToast } = useNotifications()
  const { t } = useI18N(locales)

  return useEvent((action: 'topup' | 'withdraw', cardId?: string) => {
    const card = cards?.find((item) => item.id === cardId)

    if (!card || !isIssuedCard(card)) {
      addToast({ text: t('issuing'), isClosable: false, timeout: 3500, override: true })
      return false
    }

    const rates = getCardRates(card, templates)
    const rate = action === 'topup' ? rates?.topupRate : rates?.withdrawRate

    if (hasPositiveRate(rate)) return true

    addToast({ text: t('unavailable'), isClosable: false, timeout: 3500, override: true })
    return false
  })
}
